import type { ReactNode } from 'react';

interface DrawerProps {
  /** Panel width in px. Defaults to 760 (the PRDetailDrawer / AppModal sibling width). */
  width?: number;
  onClose: () => void;
  children: ReactNode;
}

// Fixed-right slide-in drawer. Extracted from payreq.tsx's PRDetailDrawer so the
// /ap bill-detail drawer and /payreq share ONE chrome. The panel is a flex
// column at full viewport height; the caller renders its own sticky header +
// scrollable body inside `children` (see ApBillDetailDrawer / PRDetailContent).
export function Drawer({ width = 760, onClose, children }: DrawerProps) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,15,20,0.45)',
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 100,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          width,
          maxWidth: '100%',
          height: '100vh',
          boxShadow: '-30px 0 80px rgba(0,0,0,0.18)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {children}
      </div>
    </div>
  );
}
